<div class="row animated fadeIn m-1">
  <div formGroupName="companyInfo" class="p-fluid">
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
        [titleSize]="4"
        [title]="'CLIENT_CREATION.COMPANY_INFO.TITLE.CLIENT_CREATION' | translate"
        [description]="'CLIENT_CREATION.COMPANY_INFO.TITLE.CLIENT_CREATION_INFO' | translate">
      </ibp-form-header>
    </div>
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
        [titleSize]="6"
        [title]="'CLIENT_CREATION.COMPANY_INFO.TITLE.DOMAIN' | translate"
        [description]="'CLIENT_CREATION.COMPANY_INFO.TITLE.DOMAIN_INFO' | translate">
      </ibp-form-header>
      <ibp-select [label]="'CLIENT_CREATION.COMPANY_INFO.DOMAIN' | translate"
        formControlName="domain"
        class="col-12"
        [options]="domainOptions$ | async">
      </ibp-select>
      @if ((domain$ | async); as domain) {
        <rma-company-domain-info
          class="col-9 mt-3"
          [domain]="domain">
        </rma-company-domain-info>
      }
    </div>
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2 mt-3"
        [titleSize]="6"
        [title]="'CLIENT_CREATION.COMPANY_INFO.TITLE.CONTACT_PERSON' | translate"
        [description]="'CLIENT_CREATION.COMPANY_INFO.TITLE.CONTACT_PERSON_INFO' | translate">
      </ibp-form-header>
      <ibp-select [label]="'CLIENT_CREATION.COMPANY_INFO.ADDRESS_TITLE' | translate"
        formControlName="title"
        [options]="titleOptions"
        [filter]="false"
        class="col-6 mb-3 mt-2">
      </ibp-select>
      <div class="w-100"></div>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.FIRSTNAME' | translate"
        formControlName="firstname"
        class="col-6 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.LASTNAME' | translate"
        formControlName="lastname"
        class="col-6 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.EMAIL' | translate"
        formControlName="email"
        class="col-6 mb-3"
        ibpTooltip
        [content]="'CLIENT_CREATION.COMPANY_INFO.EMAIL_TOOLTIP' | translate"
        [tooltipPosition]="'bottom'">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.PHONE_NUMBER' | translate"
        formControlName="phoneNumber"
        type="tel"
        pattern="^[0-9 +()-]*$"
        class="col-6 mb-3">
      </ibp-text-input>
    </div>
    <div class="row">
      <ibp-form-header class="col-12 mb-2"
        [titleSize]="6"
        [title]="'CLIENT_CREATION.COMPANY_INFO.TITLE.COMPANY_MASTER_DATA' | translate"
        [description]="'CLIENT_CREATION.COMPANY_INFO.TITLE.COMPANY_MASTER_DATA_INFO' | translate">
      </ibp-form-header>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.COMPANY_NAME' | translate"
        formControlName="companyName"
        class="col-12 mb-3"
        ibpTooltip
        [content]="'CLIENT_CREATION.COMPANY_INFO.COMPANY_NAME_TOOLTIP' | translate"
        [tooltipPosition]="'bottom'">
      </ibp-text-input>
      <ibp-select [label]="'CLIENT_CREATION.COMPANY_INFO.CORPORATE_FORM' | translate"
        formControlName="corporateForm"
        class="col-6 mb-3"
        [options]="corporateFormOptions">
      </ibp-select>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.WEBSITE' | translate"
        formControlName="website"
        class="col-6 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.STREET' | translate"
        formControlName="street"
        class="col-9 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.BUILDING_NUMBER' | translate"
        formControlName="buildingNumber"
        class="col-3 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.ADDITIONAL_ADDRESSLINE' | translate"
        formControlName="additionalAddressline"
        class="col-9 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.POSTOFFICE' | translate"
        formControlName="postoffice"
        class="col-3 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.ZIP' | translate"
        formControlName="zip"
        class="col-3 mb-3">
      </ibp-text-input>
      <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.PLACE' | translate"
        formControlName="place"
        class="col-6 mb-3">
      </ibp-text-input>
      <ibp-select [label]="'CLIENT_CREATION.COMPANY_INFO.COUNTRY' | translate"
        formControlName="country"
        class="col-9"
        [options]="countryOptions">
      </ibp-select>
      @if (form.get('companyInfo.country')?.value == 'CH') {
        <ibp-text-input [label]="'CLIENT_CREATION.COMPANY_INFO.CANTON' | translate"
          formControlName="canton"
          class="col-3">
        </ibp-text-input>
      }
    </div>
  </div>
</div>
<div class="d-flex pt-4 justify-content-end" style="gap: 20px;">
  <ibp-button [label]="'BTN.CANCEL'"
    [icon]="['fas', 'times']"
    (onClick)="cancelCallback.emit()">
  </ibp-button>
  <ibp-button [label]="'BTN.CONTINUE'"
    [iconPos]="'right'"
    [disabled]="!isFormDisabledOrValid()"
    [icon]="['fas', 'chevron-right']"
    (onClick)="onNextClick()">
  </ibp-button>

</div>
